(function ($) {
    /**
     * Pour ouvrir les images des toolboxs en grand quand on clique dessus
     * (sauf si elles sont dans un lien)
     */
    $('img.js-img-lightbox').each(function () {
        var $this = $(this);
        $parent = $this.parent();
        if (!$parent.is('a')) {
            $this.addClass('cliquable');
            $this.magnificPopup({
                items: {
                    src: $this.attr('src')
                },
                image: {
                    markup: '<div class="mfp-figure">' +
                        '<div class="mfp-close"></div>' +
                        '<div class="mfp-img"></div>' +
                        '</div>',
                    tError: LOCALE_FO.galerie.display.errorImage
                },
                tClose: LOCALE_FO.galerie.controls.close,
                tLoading: LOCALE_FO.galerie.display.loading,
                tClose: LOCALE_FO.galerie.controls.close,
                gallery: {
                    enabled: false
                },
                type: 'image'
            });
        }
    });
})(jQuery.noConflict());
